import { useEffect, useState } from 'react';
import { getChordPlayer } from './player';

/** The current in-form playback beat (-1 when idle), for driving a playhead. */
export function usePlaybackBeat(): number {
  const [beat, setBeat] = useState(-1);
  useEffect(() => getChordPlayer().onBeat(setBeat), []);
  return beat;
}

/** The current repeat/pass through the form (1-based; 0 when idle). */
export function usePlaybackPass(): number {
  const [pass, setPass] = useState(0);
  useEffect(() => getChordPlayer().onPass(setPass), []);
  return pass;
}

/** A chorus jump waiting for the next barline (1-based), or null. */
export function usePendingChorus(): number | null {
  const [pass, setPass] = useState<number | null>(null);
  useEffect(() => getChordPlayer().onPendingChorus(setPass), []);
  return pass;
}
